export default {"src":"/_next/static/media/mobile-icon.fe87dc01.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};